// hooks/useProxyImage.ts
import { useMemo } from "react";

export function getProxyImageUrl(rawUrl?: string): string | null {
  if (typeof window === "undefined") return null;
  if (!rawUrl) {
    return null;
  }
  let key: string | null = null;
  if (rawUrl.startsWith("http")) {
    // Legacy absolute S3 URL
    key = rawUrl.split(".amazonaws.com/")[1] || null;
  } else {
    // New relative path
    key = rawUrl.startsWith("/") ? rawUrl.slice(1) : rawUrl;
  }
  if (!key) {
    return null;
  }
   const proxyUrl = key ? `/api/image/${key}` : null;
  return proxyUrl;
}

export function useProxyImage(rawUrl?: string) {
  return useMemo(() => getProxyImageUrl(rawUrl), [rawUrl]);
}
